import { RouteObject } from 'react-router-dom';
import { ROUTER_PATHNAME } from 'common/router/config';
import loadable from '@loadable/component';

import { LoginInfoContextProvider } from '@fuxi/eevee-hooks';
import { ExternalBasicLayoutWithLogin } from '@tiangong/layout/ExternalBasicLayout';

import { PriorityInternalLogin } from 'common/components';
import LoginLayout from '@tiangong/layout/LoginLayout';
import CustomLogin from '@tiangong/pages/CustomLogin';
import OpenIdLogin from '@tiangong/pages/OpenIdLogin';

const ProtocolPage = loadable(() => import('@tiangong/pages/Protocol'));
const PdfView = loadable(() => import('@tiangong/pages/PdfView'));
const ChooseRole = loadable(() => import('@tiangong/pages/CustomLogin/ChooseRole'));
const ProtocolUpdate = loadable(() => import('@tiangong/pages/CustomLogin/ProtocolUpdate'));
const BindPhone = loadable(() => import('@tiangong/pages/CustomLogin/BindPhone'));
const AppLogin = loadable(() => import('@tiangong/pages/AppLogin'));
const ComfyuiAuth = loadable(() => import('@tiangong/pages/ComfyuiAuth'));

const LoginErrorPage = loadable(() => import('@tiangong/pages/exception/LoginError'));

export const ExternalRoutes: RouteObject[] = [
  {
    path: '/u/protocol/:name',
    element: <ProtocolPage />,
  },
  {
    path: '/u/pdf',
    element: <PdfView />,
  },
  {
    path: ROUTER_PATHNAME.LOGIN,
    element: <LoginLayout seo />,
    children: [
      {
        index: true,
        path: '*',
        element: <CustomLogin />,
      },
      {
        path: ROUTER_PATHNAME.CHOOSE_ROLE,
        element: <ChooseRole />,
      },
      {
        path: ROUTER_PATHNAME.PROTOCOL_UPDATE,
        element: <ProtocolUpdate />,
      },
      {
        path: ROUTER_PATHNAME.BIND_PHONE,
        element: (
          <LoginInfoContextProvider>
            <BindPhone />
          </LoginInfoContextProvider>
        ),
      },
    ],
  },

  {
    path: ROUTER_PATHNAME.BOARD_LOGIN,
    element: <LoginLayout seo />,
    children: [
      {
        index: true,
        path: '*',
        element: <PriorityInternalLogin rootPath={ROUTER_PATHNAME.BOARD_LOGIN} />,
      },
      {
        path: ':type',
        element: <CustomLogin rootPath={ROUTER_PATHNAME.BOARD_LOGIN} />,
      },
    ],
  },

  {
    path: ROUTER_PATHNAME.OPENID_LOGIN,
    element: <OpenIdLogin />,
  },
  {
    path: ROUTER_PATHNAME.APP_LOGIN,
    element: <AppLogin />,
  },
  {
    path: ROUTER_PATHNAME.COMFYUI_AUTH,
    element: <ComfyuiAuth />,
  },
  {
    path: ROUTER_PATHNAME.LOGIN_ERROR,
    element: <LoginErrorPage />,
  },
  {
    path: '*',
    element: <ExternalBasicLayoutWithLogin />,
  },
];
